import { Directive, ElementRef, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[appPasswordEyes]',
})
export class PasswordEyesDirective implements OnInit {
  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    const a = this.renderer.createElement('a');
    this.renderer.addClass(a, 'password-eyes');
    this.renderer.listen(a, 'click', () => {
      if (this.el.nativeElement.getAttribute('type') === 'password') {
        this.el.nativeElement.setAttribute('type', 'text');
        this.renderer.addClass(a, 'active');
      } else {
        this.el.nativeElement.setAttribute('type', 'password');
        this.renderer.removeClass(a, 'active');
      }
    });

    this.renderer.appendChild(this.el.nativeElement.parentNode, a);
  }
}
